import { render, staticRenderFns } from "./BundleOffer.vue?vue&type=template&id=1a8e4d9f&scoped=true"
import script from "./BundleOffer.vue?vue&type=script&setup=true&lang=ts"
export * from "./BundleOffer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BundleOffer.vue?vue&type=style&index=0&id=1a8e4d9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8e4d9f",
  null
  
)

export default component.exports